const CANDIDATE_PORTAL_SURVEY_STATUS_NEW: string = 'Respond Now';
const CANDIDATE_PORTAL_SURVEY_STATUS_RESPONSE_PENDING: string = 'Response Pending';
const CANDIDATE_PORTAL_SURVEY_STATUS_SUBMITTED: string = 'Responded';
const CANDIDATE_PORTAL_SURVEY_STATUS_CODE_NEW: string = 'New';
const CANDIDATE_PORTAL_SURVEY_STATUS_CODE_RESPONSE_PENDING: string = 'Partial Save';
const CANDIDATE_PORTAL_SURVEY_STATUS_CODE_SUBMITTED: string = 'Submitted';
const CANDIDATE_PORTAL_SURVEY_TODAY_TEXT: string = 'Today';
const SURVEY_DETAILS_SUCCESS_MESSAGE : string = 'Survey Details Saved Successfully';
const SURVEY_DETAILS_ERROR_MESSAGE : string = 'Error, please refresh the page';
const SURVEY_QUESTION_CODE_TEXT = '04';
const SURVEY_QUESTION_CODE_MULTIPLE_CHOICE = '01';
const SURVEY_QUESTION_CODE_RADIO = '03';
const SURVEY_QUESTION_CODE_RATING = '06';
const SURVEY_QUESTION_CODE_UPLOAD_FILE = '11';
const SURVEY_QUESTION_CODE_DROPDOWN = '12';
const SURVEY_QUESTION_CODE_DATE = '13';
const SURVEY_FEEDBACK_QUESTION_CODE_TEXT = '07';
const SURVEY_END_MESSAGE = '90';
const RATING_F_QUES_CONDITION_ID_LESS_THAN : string = '01';
const RATING_F_QUES_CONDITION_ID_GREATER_THAN : string = '02';
const RATING_F_QUES_CONDITION_ID_EQUAL : string = '03';
const SURVEY_DETAILS_DATA_FETCHING_MESSAGE : string = 'Survey Details are being fetched..';
export  {
    CANDIDATE_PORTAL_SURVEY_STATUS_NEW,
    CANDIDATE_PORTAL_SURVEY_STATUS_RESPONSE_PENDING,
    CANDIDATE_PORTAL_SURVEY_STATUS_SUBMITTED,
    CANDIDATE_PORTAL_SURVEY_TODAY_TEXT,
    CANDIDATE_PORTAL_SURVEY_STATUS_CODE_RESPONSE_PENDING,
    CANDIDATE_PORTAL_SURVEY_STATUS_CODE_SUBMITTED,
    CANDIDATE_PORTAL_SURVEY_STATUS_CODE_NEW,
    SURVEY_DETAILS_SUCCESS_MESSAGE,
    SURVEY_QUESTION_CODE_TEXT,
    SURVEY_QUESTION_CODE_MULTIPLE_CHOICE,
    SURVEY_QUESTION_CODE_RADIO,
    SURVEY_QUESTION_CODE_RATING,
    SURVEY_QUESTION_CODE_UPLOAD_FILE,
    SURVEY_FEEDBACK_QUESTION_CODE_TEXT,
    RATING_F_QUES_CONDITION_ID_EQUAL,
    RATING_F_QUES_CONDITION_ID_GREATER_THAN,
    RATING_F_QUES_CONDITION_ID_LESS_THAN,
    SURVEY_DETAILS_ERROR_MESSAGE,
    SURVEY_DETAILS_DATA_FETCHING_MESSAGE,
    SURVEY_QUESTION_CODE_DROPDOWN,
    SURVEY_QUESTION_CODE_DATE,
    SURVEY_END_MESSAGE
}